import React from 'react'
import { Heading } from '@myxplor/ui'
import { fileNameWithDate } from '../../io/download-csv'
import ReportForm from '../views/form'
import { NotAvailable } from './not-available'

const apiEndPoint = ({ gov_id, record_type }) =>
  `${process.env.REACT_APP_API_HOST}/api/${record_type}/${gov_id}/missing-approvals`

const onSubmit = ({ gov_id, record_type }) => ({ remote_request }) => () =>
  remote_request.submit({
    url: apiEndPoint({ gov_id, record_type }),
    method: 'GET',
    fileName: fileNameWithDate('Outstanding CWAs'),
  })

const FormFields = () => (
  <fieldset>
    <Heading small>Missing CWA Report</Heading>
    This will generate a <abbr title="CSV files can be opened in any spreadsheet program">CSV</abbr>{' '}
    report of your enrolments that are currently missing a <abbr title="Complying Written Agreement">CWA</abbr>.
  </fieldset>
)

export const ReportMissingApprovals = ({ gov_id, record_type, resetCurrentReport }) => (
  gov_id ?
    <ReportForm
      onSubmit={onSubmit({ gov_id, record_type })}
      name="Missing CWA Report"
      fieldsComponent={FormFields}
      resetCurrentReport={resetCurrentReport}
    /> :
    <NotAvailable>
      This report can only be run against one centre at a time
    </NotAvailable>
)



// WEBPACK FOOTER //
// ./src/reports/reports/missing-approvals.jsx